// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bank-logo":"GhP6o5","icon":"_3LfWVL"};